import React, { useState, useEffect } from 'react';
import {getRoles} from "../auth";

interface UserModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: () => void;
    user: any;
}

interface Role{
    id: number;
    name: string;
    description: string;
}

const UserModal: React.FC<UserModalProps> = ({ isOpen, onClose, onSave, user }) => {
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('');
    const [roles, setRoles] = useState<string[]>([]);

    useEffect(() => {
        if (user) {
            setEmail(user.email);
            setRole(user.role);
        } else {
            setEmail('');
            setRole('');
        };
    }, [user]);

    const fetchRoles = async () => {
        try {
            const rolesData = await getRoles();
            const roleNames = rolesData.map((role: Role) => role.name)
            setRoles(roleNames);
        } catch (error) {
            console.error('Erreur lors de la récupération des rôles', error);
        }
    };

    useEffect(() => {
        fetchRoles();
    }, []);

    const handleSave = () => {
        // Sauvegarder l'utilisateur (créer ou modifier)
        if (user) {
            console.log('Modifying user', { id: user.id, email, role });
        } else {
            console.log('Creating user', { email, role });
        }
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                <h2 className="text-xl font-bold mb-4">
                    {user ? 'Modifier l\'utilisateur' : 'Créer un utilisateur'}
                </h2>
                <div className="mb-4">
                    <label className="block text-gray-700">Email</label>
                    <input
                        type="email"
                        className="w-full p-2 mt-2 border rounded-md"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700">Rôle</label>
                    <select
                        className="w-full p-2 mt-2 border rounded-md"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                    >
                        <option value="" disabled>Sélectionnez un rôle</option>
                        {roles.map((roleOption) => (
                            <option key={roleOption} value={roleOption}>
                                {roleOption}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        className="bg-gray-500 text-white px-4 py-2 rounded-md mr-2"
                    >
                        Annuler
                    </button>
                    <button
                        onClick={handleSave}
                        className="bg-blue-500 text-white px-4 py-2 rounded-md"
                    >
                        Sauvegarder
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserModal;
